import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const NoBookContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 60px;
    margin-bottom: 60px;
    margin-top: 75px;
  }
  .description {
    font-size: 24px;
    margin-bottom: 198px;
    color: ${colors.dark7};
    max-width: 66%;
    text-align: center;
  }

  @media (max-width: ${breakpoints.md}px) {
    .title {
      font-size: 40px;
      margin-bottom: 40px;
      margin-top: 50px;
    }
    .description {
      font-size: 16px;
      margin-bottom: 132px;
      color: ${colors.dark7};
      max-width: 80%;
    }
  }
  @media (max-width: ${breakpoints.xs}px) {
    .title {
      max-width: 90%;
    }
    .description {
      max-width: 90%;
    }
  }
`
